// カードを新規追加するモーダルのコンポーネント

import React, { useState } from 'react';

import './CommonModal.css';

// React Modalで実装
import Modal from 'react-modal';
import { Link } from 'react-router-dom';

const CommonModal = ({modalIsOpen, message, linkMessage, link}) => {
    
    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                className="common-modal"
                overlayClassName="common-modal-overlay"
                contentLabel="Common Modal"
            >
                <div className="common-modal-content">
                    <div className="common-modal-message">{message}</div>
                    <div className="common-modal-link">
                        <Link to={link}><button className="common-modal-link-button">{linkMessage}</button></Link>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default CommonModal;